export default class FlagController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    this._$attrs.$addClass('vd-flag-container')
  }
}
